export default "__VITE_ASSET__BLw_JEqF__"